"use client";
import { Grid2 } from "@repo/ui";
import Image from "next/image";
import { Suspense } from "react";
import BrochureForm, { BrochureFormProps } from "./BrochureForm";

function DownloadBrochureForm({
  formType,
  serviceId,
  heading,
}: BrochureFormProps) {
  return (
    <Grid2 container spacing={1}>
      <Grid2 size={{ sm: 12, md: 5, lg: 5 }} className="relative">
        <Image
          src="/images/Spoclearn-Corporate-Brochure-2025-min.jpg"
          alt="spoclearn-download-banner"
          quality={100}
          fill
          className="object-fill"
        />
      </Grid2>
      <Grid2 size={{ sm: 12, md: 7, lg: 7 }}>
        <Suspense>
          <BrochureForm
            formType={formType}
            serviceId={serviceId}
            heading={heading}
          />
        </Suspense>
      </Grid2>
    </Grid2>
  );
}

export default DownloadBrochureForm;
